import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {StoreState} from "../Store";

export interface StateProps {
    token: string | null;
}

const initialState: StateProps = {
    token: null
}

const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        // Change token
        updateToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload
        }
    }
})

export default authSlice.reducer
// Update token
export const {updateToken} = authSlice.actions
// Get token
export const useGetAuthToken = () => useSelector((state: StoreState) => state.auth.token)